<p-panel header="Select Provider Address">
  <p-table
    selectionMode="single"
    data-test-id="select-provider-table"
    [value]="providers"
    [paginator]="true"
    [rows]="10"
    (onRowSelect)="selectProvider($event.data)"
    >
    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track col) {
          <th>
            {{col.header}}
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-provider>
      <tr [pSelectableRow]="provider">
        @for (col of cols; track col) {
          <td [style]="{ 'width': '18rem' }">
            @switch (col.field) {
              @case ('phone') {
                {{ provider.physicianAccountDTO[col.field] | phoneNumber }}
              }
              @case ('physicalZip') {
                {{ provider.physicianAccountDTO[col.field] | zipCode }}
              }
              @case ('physicalCity') {
                {{ provider.physicianAccountDTO[col.field] }}
              }
              @case ('physicalState') {
                {{ provider.physicianAccountDTO[col.field] }}
              }
              @default {
                <span
                  [pTooltip]="provider.physicianAccountDTO[col.field]"
                  tooltipPosition="bottom"
                  >
                  {{ provider.physicianAccountDTO[col.field] }}
                </span>
              }
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</p-panel>
